import { Navigate, Route, Routes } from 'react-router-dom';
import AdminGate from './components/AdminGate';
import AdminLayout from './components/AdminLayout';
import LoginPage from './pages/LoginPage';
import StatsPage from './pages/StatsPage';
import GospelPage from './pages/GospelPage';
import CrudPage from './pages/CrudPage';
import { CRUD_CONFIGS } from './pages/crudConfig';
import MissionaryCreatePage from './pages/MissionaryCreatePage';
import MissionariesPage from './pages/MissionariesPage';
import InscriptionsPage from './pages/InscriptionsPage';
import NotifyPage from './pages/NotifyPage';
import RosarioPage from './pages/RosarioPage';
import MusicaCinePage from './pages/MusicaCinePage';

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/"
        element={
          <AdminGate>
            <AdminLayout />
          </AdminGate>
        }
      >
        <Route index element={<Navigate to="stats" replace />} />
        <Route path="stats" element={<StatsPage />} />
        <Route path="gospel" element={<GospelPage />} />
        {Object.entries(CRUD_CONFIGS).map(([key, config]) => (
          <Route key={key} path={key} element={<CrudPage config={config} />} />
        ))}
        <Route path="missionary" element={<MissionaryCreatePage />} />
        <Route path="missionaries" element={<MissionariesPage />} />
        <Route path="inscriptions" element={<InscriptionsPage />} />
        <Route path="notify" element={<NotifyPage />} />
        <Route path="rosario" element={<RosarioPage />} />
        <Route path="musica-cine" element={<MusicaCinePage />} />
        <Route path="*" element={<Navigate to="/stats" replace />} />
      </Route>
    </Routes>
  );
}
